import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";

const StarNewScheduleForm = ({ schedule, selectedSchedule }) => {
  // const [inputFieldList, setInputFieldList] = useState([
  //     { event_type: '', from: '', to: '', date: schedule.format()},
  // ])

  const [inputFieldList, setInputFieldList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setInputFieldList(selectedSchedule);
    if (selectedSchedule.length < 1) {
      setInputFieldList([
        ...selectedSchedule,
        { event_type: "", from: "", to: "", date: schedule.format() },
      ]);
    }
  }, [selectedSchedule]);

  const handleChangeInput = (index, event) => {
    const values = [...inputFieldList];
    values[index][event.target.name] = event.target.value;
    setInputFieldList(values);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/star/add_schedule`, inputFieldList).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
        } else if (res.data.status === 422) {
          swal("Error", res.data.message, "error");
        } else {
          setInputFieldList({
            ...inputFieldList,
            error_list: res.data.validation_errors,
          });
        }
      });
    });
  };

  const handleAddClick = (index) => {
    setInputFieldList([
      ...inputFieldList,
      { event_type: "", from: "", to: "", date: schedule.format() },
    ]);
  };

  const handleRemoveClick = (index) => {
    const fieldList = [...inputFieldList];
    fieldList.splice(index, 1);
    setInputFieldList(fieldList);
  };

  return (
    <>
      <form className="row" onSubmit={handleSubmit}>
        {inputFieldList.map((inputField, i) => {
          return (
            <>
              <div className="col-md-10 row mx-auto">
                <div className="col-md-4">
                  <div className=" mb-2 text-black">
                    <div className="d-flex">
                      <h5 className="mt-2 text-warning col-md-4 Width-Ms">
                        Event Type
                      </h5>
                      <select
                        className="col-md-8 reply-control text-black"
                        name="event_type"
                        onChange={(event) => handleChangeInput(i, event)}
                        value={inputField.event_type}
                      >
                        <option value="">Select One</option>
                        <option value="livechat">Live Chat</option>
                        <option value="learning">Learning Session</option>
                        <option value="meetup">Meetup Event</option>
                        <option value="qna">QnA Session</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className=" mb-2 text-black">
                    <div className="d-flex">
                      <h5 className="mt-2 text-warning col-md-3">From</h5>
                      <input
                        className="col-md-9 reply-control text-black"
                        type="time"
                        name="from"
                        onChange={(event) => handleChangeInput(i, event)}
                        value={inputField.from}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className=" mb-2 text-black">
                    <div className="d-flex">
                      <h5 className="mt-2 text-warning col-md-3 Width-Ms">
                        To
                      </h5>
                      <input
                        className="col-md-9 reply-control text-black"
                        type="time"
                        name="to"
                        onChange={(event) => handleChangeInput(i, event)}
                        value={inputField.to}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-1">
                  <div className=" mb-2 text-black">
                    <div className="d-flex">
                      <span
                        onClick={() => handleRemoveClick(i)}
                        className="btn btn-danger px-4 mx-4"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })}

        <div className="d-flex mt-4 mb-5 pb-4 justify-content-center">
          {loading ? (
            <button className="btn btnSave fw-bold bntTSC">
              <i className="fas fa-spinner fa-pulse"></i>{" "}
            </button>
          ) : (
            <button
              type="submit"
              onClick={handleSubmit}
              className="btn btnSave fw-bold bntTSC"
            >
              <i class="fa-solid fa-bookmark"></i> Save
            </button>
          )}

          <button
            onClick={() => handleAddClick()}
            type="button"
            className="btn btnConfirm fw-bold mx-3 bntTSC "
          >
            <i className="fas fa-plus"></i> &nbsp;New Schedule
          </button>
        </div>
      </form>
    </>
  );
};

export default StarNewScheduleForm;
